// Card Sliders
const entryListSliders = document.querySelectorAll('.js-slider--entry-list'),
    swiperInstances = [],
    delay = 250;

let throttled = false;

function handleEntryLists() {
    entryListSliders.forEach((el) => {
        // Instantiate swiper if window is < 800px
        if (window.innerWidth < 800) {
            swiperInstances.push(new Swiper(el, {
                containerModifierClass: 'slider',
                wrapperClass: 'slider__wrapper',
                slideClass: 'slide',
                slidesPerView: 'auto',
                slidesOffsetAfter: -8,
                freeMode: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            }));
        } else {
            // Destroy any swiper instances
            swiperInstances.forEach(swiper => {
                swiper.destroy(true, true);
            });
        }
    });
}

// window.resize event listener
window.addEventListener('resize', function() {
    // Only run if we're not throttled
    if (!throttled) {
        handleEntryLists();

        throttled = true;

        // Set a timeout to un-throttle
        setTimeout(function() {
            throttled = false;
        }, delay);
    }
});

handleEntryLists();
